import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';

import { Alert, Button } from 'antd';

import { EAnticipationStatus } from 'v2/interfaces/user';
import eduzzAccountsService from 'v2/services/eduzzAccount';

const ChargebackAlert = () => {
  const [visible, setVisible] = useState(true);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;
  if (!user || user?.anticipation_status === EAnticipationStatus.LIBERADO) return null;

  return (
    <>
      <Alert
        type={user?.anticipation_status === EAnticipationStatus.BLOQUEADO ? 'error' : 'warning'}
        showIcon
        action={
          <Button onClick={handleClose} aria-label='fechar'>
            Entendi
          </Button>
        }
        className='max-sm:flex-col max-sm:items-center max-sm:text-center'
        message={<span className='font-bold'>Atenção</span>}
        description={
          <span>
            {user?.anticipation_status_message}{' '}
            <a
              href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807649349-O-que-e-Chargeback-e-como-funcionam-seus-%C3%ADndices'
              target='_blank'
              rel='noopener noreferrer'
            >
              O que é chargeback?
            </a>
          </span>
        }
      />
    </>
  );
};

export default ChargebackAlert;
